<template>
<div id="package-wrapper">
  <div class="package-composer">
    <div class="container">
      <enter-postcode v-if="step === 0" @check="checkPostcode" />
      <select-preset v-else-if="step === 1" @select="goTo(2)" @to0="refresh()" />
      <select-options v-else-if="step === 2" @next="goTo(3)" @to1="goTo(1)"/>
      <enter-details v-else-if="step === 3" @to2="goTo(2)" />
    </div>
  </div>
</div>
</template>

<script>
import EnterPostcode from './steps/0-enter-postcode.vue'
import SelectPreset from './steps/1-select-preset'
import SelectOptions from './steps/2-select-options'
import EnterDetails from './steps/3-enter-details'
import State from './state'
import Vue from 'vue'
import validation from './validation'
Vue.use(validation)

const urlParams = new URLSearchParams(window.location.search)

State.zipcode = urlParams.get('zipcode')
State.houseno = urlParams.get('houseno')
State.houseno_ext = urlParams.get('houseno_ext')
State.type = urlParams.get('type')

export default {
  components: {
    EnterPostcode,
    SelectPreset,
    SelectOptions,
    EnterDetails
  },
  data () {
    return {
      step: 1
    }
  },
  mounted () {
    window.onpopstate = this.handlePopState(event)
  },
  created () {
    if (!State.type) {
      State.type = 'thuis'
    }
    if (!State.zipcode || !State.houseno) {
      this.step = 0
    }
  },
  methods: {
    refresh () {
      location.reload()
    },
    checkPostcode (event) {
      urlParams.set('zipcode', event.postcode)
      urlParams.set('houseno', event.houseNumber)
      urlParams.set('houseno_ext', event.houseNumberExt)

      document.location.search = urlParams
    },
    goTo (step) {
      if ('scrollBehavior' in document.documentElement.style) {
        window.scrollTo(0, 0)
      } else {
        window.scrollTo(0, 0)
      }
      if (step > this.step) {
        history.pushState({ step: step }, document.title)
      }
      this.step = step
    },
    handlePopState (event) {
      console.log('handlepopstate')
      console.log(event)
      // this.step--
      return false
    }
  }
}
</script>

<style lang="scss">

.swal-title {
  font-family: "Montserrat", Sans-serif;
}

.swal-text {
  font-family: "Montserrat", Sans-serif;
  text-align: center;
}

.swal-button.swal-button--yes {
  background-color: #7cd1f9;

  &:focus {
    background-color: #7cd1f9;
  }
}

.package-composer {
  padding-top: 100px;
  padding-bottom: 100px;

  font-family: "Montserrat", Sans-serif;
  color: #4d4d4d;
  background-color: #ededed;

  .container {
    max-width: 1140px;
    margin: 0 auto;
    padding: 30px 0;
  }

  .title {
    text-align: center;
    margin-bottom: 50px;
  }

  .block {
    background: white;
    border-radius: 5px;
    margin: $block-margin;
    padding: 20px;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
  }

  h4 {
    font-size: unset;
    font-weight: 700;
    line-height: normal;
  }

  button {
    font-weight: 300;
    background-color: color('button');
    padding: 8px 40px;
    text-transform: uppercase;
    color: #fff;
    border-radius: 5px;
    border: none;
    outline: none;
    font-family: inherit;
    font-size: 20px;
    letter-spacing: 1px;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background-color: darken(color('button'), 10%);
    }

    @each $i, $color in $colors {
      &.btn-#{$i} {
        background: $color;

        &:hover {
          background-color: darken($color, 10%);
        }
      }
    }
  }

  .form-group {
    label {
      display: block;
      font-weight: 300;
      font-size: 14px;
      margin-bottom: 3px;
    }

    input {
      background-color: #f5f5f5;
      border: 2px solid #cecece;
      outline: none;
      font-family: inherit;
      padding: 9px 10px;
      font-size: 15px;
      border-radius: 5px;
      transition: border-color 0.2s;

      &:focus {
        border-color: color(2);
      }
    }
  }

  * {
    box-sizing: initial !important;
  }
}
</style>

<style>
@font-face {
  font-family: "Lato";
  src: local("Lato"),
  url(./fonts/Lato/Lato-Black.ttf) format("truetype");
}
</style>
